/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable react/no-unescaped-entities */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import ApplicationContext from '../../../../context/ApplicationContext';
import NextButton from '../../../../components/Button/NextButton';
import AnimatedButton from '../../../../components/Button';
import ThreeDotsBlackLoader from '../../../../components/LoadingDots/ThreeDotsBlack';
import { appointmentLanguageContent } from '../../../Appointments/appointmentLanguageContent';
import { reviewLanguageContent } from '../../../Review/reviewLanguageContent';
import DigitalSignature from '../Components/Fields/DigitalSignature';
import Signature from '../Components/Fields/Signature';
import HTMLViewer from '../../../../components/HTMLViewer';
import { dataURLtoFile } from '../../../../helpers/CommonFunctions';
import { v4 as uuidv4 } from 'uuid';
import S3UploadHook from '../../../../helpers/UploadToS3';
import { dataService } from '../../../../services/data.service';

function SignatureMain(props) {
    const { sessionData, handlePage, selectedLanguage, facilityData, selectedLanguageName, signatureForms, signatureState, setSignatureState } = useContext(ApplicationContext);
    const [showForms, setShowForms] = useState(false);
    const [signatureType, setSignatureType] = useState(sessionData.patient_details.signature_type || signatureState.signature_type || 'draw');
    const [loader, setLoader] = useState(false);
    const [isSignatureDrawn, setIsSignatureDrawn] = useState(false);

    const [browserInfo, setBrowserInfo] = useState({
        userAgent: '',
        language: '',
        platform: '',
        vendor: '',
        cookieEnabled: false,
        hardwareConcurrency: 0,
        deviceMemory: 0,
        onLine: false,
        maxTouchPoints: 0,
        appName: '',
        appVersion: '',
        connection: {},
        doNotTrack: '',
        geolocation: '',
        mimeTypes: [],
        plugins: [],
        storageEstimate: {},
        permissions: {},
    });

    useEffect(() => {
        // Fetch geolocation (if permission is granted)
        const fetchGeolocation = () => {
            return new Promise((resolve) => {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            resolve(`Latitude: ${position.coords.latitude}, Longitude: ${position.coords.longitude}`);
                        },
                        () => resolve('Geolocation not allowed'),
                    );
                } else {
                    resolve('Geolocation not supported');
                }
            });
        };
    
        // Fetch storage estimation
        const fetchStorageEstimate = async () => {
            if (navigator.storage && navigator.storage.estimate) {
                return await navigator.storage.estimate();
            }
            return {};
        };
    
        // Fetch permissions
        const fetchPermissions = async () => {
            if (navigator.permissions) {
                const permissionStatus = await navigator.permissions.query({ name: 'geolocation' });
                return permissionStatus.state;
            }
            return 'Permission API not supported';
        };
    
        // Fetch connection info
        const fetchConnection = () => {
            return navigator.connection || {};
        };
    
        const fetchInfo = async () => {
            // const geolocation = await fetchGeolocation();
            const storageEstimate = await fetchStorageEstimate();
            const permissions = await fetchPermissions();
    
            const info = {
                userAgent: window.navigator.userAgent,
                language: window.navigator.language,
                platform: window.navigator.platform,
                vendor: window.navigator.vendor,
                cookieEnabled: window.navigator.cookieEnabled,
                hardwareConcurrency: window.navigator.hardwareConcurrency,
                deviceMemory: window.navigator.deviceMemory,
                onLine: window.navigator.onLine,
                maxTouchPoints: window.navigator.maxTouchPoints,
                appName: window.navigator.appName,
                appVersion: window.navigator.appVersion,
                connection: fetchConnection(),
                doNotTrack: window.navigator.doNotTrack,
                // geolocation,
                mimeTypes: Array.from(window.navigator.mimeTypes).map(mime => mime.type),
                plugins: Array.from(window.navigator.plugins).map(plugin => plugin.name),
                storageEstimate,
                permissions,
            };
    
            setBrowserInfo(info);
        };
    
        fetchInfo();
    }, []);

    const handleUI = () => {
        let ui = '';
        switch(signatureType) {
        case 'type': ui = <DigitalSignature signatureType={signatureType} signatureState={signatureState} setSignatureState={setSignatureState} />
            break;
        default: ui = <Signature loader={loader} setIsSignatureDrawn={setIsSignatureDrawn} signatureType={signatureType} signatureState={signatureState} setSignatureState={setSignatureState} />;
        }
        return ui;
    }

    const handleNextNavigation = async () => {
        setLoader(true);
        if(sessionData?.patient_details?.signature_url === '') {
            const tempState = signatureState;
            if(signatureType === 'draw') {
                const canvas = document.getElementById(`signatureCanvas`);
                const ctx = canvas?.getContext("2d");
                const signatureData = canvas.toDataURL();
                tempState['signature_value'] = signatureData;
            } else {
                const canvas = document.getElementById(`digitalCanvas`);
                const ctx = canvas?.getContext("2d");

                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.strokeStyle = "#000"; // Signature color
                ctx.lineWidth = 4; // Signature line width
                ctx.font = `50px ${signatureState.selected_font || "'Alex Brush', cursive"}`; // Use the selected font
                ctx.fillStyle = "#000"; // Font color
                // Draw the user's name in the specified format
                ctx.fillText(signatureState.user_name, 10, 50); // Adjust the position as needed
                const signatureData = canvas.toDataURL();
                tempState['signature_value'] = signatureData;
            }
            var file = dataURLtoFile(tempState.signature_value, `${uuidv4()}-${sessionData.patient_id}.jpeg`);
            // 4th parameter is for whether the image is private(false) or public(true)
            const url= await S3UploadHook(file, `signatures/${sessionData.facility_id}`, null, false);
            if(url) {
                const val =`signatures/${sessionData.facility_id}/${file.name}`;

                const payload = {
                    "signature_type": signatureType,
                    "signature_url": val,
                    "signature_username": signatureState.user_name,
                    "signature_user_initials": signatureState.user_initials,
                    "browser_details": browserInfo
                }
                dataService.UpdatePatientSignature(payload).then((res) => {
                    if(res.error === false) {
                        let signatureSession = null;
                        if(Object.keys(sessionData.signature_session).length === 0) {
                            signatureSession = {
                                selected_font: tempState.selected_font,
                                selected_font_class: tempState.selected_font_class
                            }
                        }
                        handlePage('review', '', '','', '', '', '', signatureSession);
                        setLoader(false);
                    }
                })
            }
        } else {
            let signatureSession = null;
            if(sessionData?.patient_details?.signature_url === '') {
                signatureSession = signatureState
            }
            const payload = {
                "signature_type": signatureType,
                "signature_username": signatureState.user_name,
                "signature_user_initials": signatureState.user_initials
            }
            dataService.UpdatePatientSignature(payload).then((res) => {
                if(res.error === false) {
                    handlePage('review', '', '','', '', '', '', signatureSession);
                    setLoader(false);
                }
            })
        }
    }

    useEffect(() => {
        if(!sessionData.is_signature_document_exist) {
            setLoader(true);
            handlePage('review', '', '','', '', '', '', sessionData.signature_session);
        } else {
            if(sessionData?.patient_details?.signature_url !== '') {
                setSignatureState({
                    user_name: sessionData?.patient_details?.signature_username,
                    user_initials: sessionData?.patient_details?.signature_user_initials,
                    signature_type: sessionData?.patient_details?.signature_type,
                    signature_value: sessionData?.patient_details?.signature_url,
                    selected_font: sessionData?.signature_session?.selected_font,
                    selected_font_class: sessionData?.signature_session?.selected_font_class,
                    signed_at: sessionData?.patient_details?.signed_at,
                });
                setIsSignatureDrawn(true);
            }
        }
    }, [])

    return (
        <div className='absolute z-[9] w-full top-[100px] flex flex-col justify-between doc-height'>
            <div>
                <button data-testid={`view-form`} 
                    onClick={() => setShowForms(!showForms)} className={`bg-[#333] text-[#F2F2F2] -top-[43px] right-[15px] absolute px-[12px] py-[6px] flex items-center rounded-full w-auto font-semibold text-base`}>
                    <img src="/images/View.svg" className='mr-[10px]' alt="view" />
                    {reviewLanguageContent['view'][selectedLanguage]}
                </button>
                <div>
                    <div className='pb-2 border-t border-[#70B503] h-signature overflow-auto Form-scroll'>
                        {showForms &&
                        <motion.div 
                            variants={{
                                hidden: { opacity: 0, y: -20 },
                                visible: { opacity: 1, y: 0, transition: { duration: 0.2 } },
                            }}
                            initial="hidden"
                            animate="visible" className='py-[12px]'>
                            {signatureForms.map((item, index) => (
                                <div key={`sign-${index}`} className={`flex items-center px-[20px]  ${index === signatureForms.length - 1 ? 'border-b border-[#70B503] pb-[12px]' : 'pb-[8px]'}`}>
                                    <span className={`bg-[#007EB4] rounded-[50%] h-[25px] py-0.5 px-2 text-sm text-[#F2F2F2] mr-3`}>{index + 1}</span>
                                    <span className='text-sm font-semibold break-words'>{item.form_name || item.name}</span>
                                </div>
                            ))}
                        </motion.div>}
                        <div className='mr-2'>
                            <div className={`facility-profile mt-[16px] font-normal text-justify text-sm text-[#333] px-[20px] ${selectedLanguage === 'ar' ? 'dir-rtl' : ''}`}>
                                <HTMLViewer htmlContent={facilityData.doc_signature_legal_consent[selectedLanguageName]} />
                            </div>
                            <div data-testid="signature_screen" className='py-[30px]'>
                                {handleUI()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`flex mb-[24px] justify-between mx-[16px] w-auto fold-gap gap-[12px]`}>
                <AnimatedButton handleClick={() => {setSignatureType(signatureType === 'draw' ? 'type' : 'draw'); setIsSignatureDrawn(false)}}
                    id="other" disabled={loader || sessionData?.patient_details?.signature_url !== ''} 
                    className={`font-semibold text-gray w-[200px] h-[40px] pl-[24px] bg-[#F2F2F2] fold-normal-text text-[16px] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[18px] justify-start`}>
                    <img src="/images/signature-type.svg" alt="signature-type" className='mr-[20px] w-[1.7em] h-[1.7em]' />
                    {appointmentLanguageContent['other'][selectedLanguage]}
                </AnimatedButton>
                <NextButton loader={loader} disabled={loader ||  (signatureType === 'draw' && (isSignatureDrawn === false)) || (signatureType === 'type' && (signatureState.user_name.trim() === '' || signatureState.user_initials.trim() === ''))} handleClick={() => handleNextNavigation()} />
            </div>
        </div>
    );
}

export default SignatureMain;